import React from 'react'

const DashGlobalIntroduction = () => {
  return (
    <>
        <section id="first" className="about bg2">
  <div className="container">
    <div className="section-title">
      <br />
      <h2 className="animated fadeInDown">Introduction</h2>
      <div className="bar" />
      <div className="row">
        <div className="col-lg-12">
          <div className=" cd-intro-content bouncy shadow animated swing">
            <div className="row">
              <div className="col-md-12">
                <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                  Dash-Global
                </h3>
                <p className="mx-auto text-justify p-3">
                  In the home screen you will find all the various categories of
                  product where the customer can choose anyone according to
                  his/her needs and purchase the product. In dash global there's
                  a feature to compare two or more products so that the customer
                  can get the best product, once the customer has selected a
                  product then he/she can add the product to the cart option and
                  after that can click on the checkout for payment option. In
                  this vendor can add their product too, vendors have to
                  register themselves first, to add products and maintain all
                  the records/reports vendors will have a different panel to do
                  the same.
                </p>
              </div>
              {/* <div className="col-lg-4 col-md-4">
                <div className="m-3">
                  <div className="video-responsive mt-5">
                    <video width="100%" height={200} controls="">
                      <source
                        src="assets/img/all-banner/Alobah-Final.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default DashGlobalIntroduction